<style lang="scss" src="./OrderAddProductModal.scss"></style>
<template>
  <div class="OrderAddProductModal" @click.stop="closeAddModal">
      <div class="OrderAddProductModal__content" :style="modalStyle" @click.stop="()=>false">
        <ProductDetails :product="product" />
        <ProductFormats 
          :formats="formats" 
          @formatChanged="onSelectedFormat" 
          v-if="formats && formats.length > 0"
        />
        <ProductExtras 
          :extras="extras" 
          @optionsChanged="onOptionsChanged" 
          @optionMenuSelected="onOptionMenuSelected" 
          v-if="extras && extras.length > 0" 
        />
        <ProductActions 
          :product="product" 
          :total="getTotal"
          @addToCart="onAddToCart" 
          @udsChanged="onUdsChanged"
        />
        <div class="btn-close" @click="closeAddModal">
          <i class="fa fa-times"/>
        </div>
      </div>

      <!-- menuAddProductModal -->
      <div 
        class="OrderAddProductModal" 
        @click.stop="closeMenuAddModal" 
        v-if="(menu_product && menu_product.CODARTICULO) && (menu_option_opened && menu_option_opened.extra.CODMODIFICADOR)"
      >
        <div class="OrderAddProductModal__content" style="top: 72px;" @click.stop="()=>false">
          <ProductDetails :product="menu_product" />
          <ProductFormats
            :formats="menu_product_formats" 
            @formatChanged="onSelectedFormat" 
            v-if="menu_product_formats && menu_product_formats.length > 0"
          />
          <ProductExtras 
            :extras="menu_product_extras" 
            @optionsChanged="onMenuProductOptionsChanged" 
            v-if="menu_product_extras && menu_product_extras.length > 0" 
          />
          <div class="product-action">
            <button class="btn btn-info btn-block" @click="onAddToProductExtra">
              <span>AÑADIR AL MENU</span>
            </button>
          </div>
          <div class="btn-close" @click="closeMenuAddModal">
            <i class="fa fa-times"/>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import ProductDetails from './ProductDetails'
import ProductFormats from './ProductFormats'
import ProductExtras from './ProductExtras'
import ProductActions from './ProductActions'

export default {
  components: {
    ProductDetails,
    ProductFormats,
    ProductExtras,
    ProductActions
  },
  props: {
    product: { required: true },
    formats: { default: null },
    extras: { default: null }
  },
  data() {
    return {
      uds: 1,
      selectedFormat: {},
      selectedExtras: [],
      selectedMenuProducFormat: {},
      selectedMenuProductExtras: [],
      menu_option_opened: {},
      menu_product: {},
      menu_product_formats: {},
      menu_product_extras: [],
      errors: []
    }
  },
  computed: {
    modalStyle() {
      return this.extras && this.extras.length > 0 ? { top: '1rem' } : {}
    },
    getTotal() {
      let total = 0
      total = Number(this.product.PVP || 0)
      if (this.formats && this.formats.length > 0) {
        total = Number(this.selectedFormat.PVP || 0)
      }
      if (this.extras && this.extras.length > 0) {
        this.selectedExtras.forEach(e => {
          const { options } = e
          options.forEach(o => {
            const incPvp = Number(o.INCPRECIO || 0)
            total += incPvp
          })
        })
      }
      return (total * this.uds).toFixed(2)
    },
    getMenuProductTotal() {
      let total = 0
      total = Number(this.menu_product.PVP || 0)
      if (this.menu_product_formats && this.menu_product_formats.length > 0) {
        const incPvp = Number(this.selectedMenuProducFormat.INCPRECIO || 0)
        total += incPvp
      }
      if (this.menu_product_extras && this.menu_product_extras.length > 0) {
        this.selectedMenuProducExtras.forEach(e => {
          const { options } = e
          options.forEach(o => {
            const incPvp = Number(o.INCPRECIO || 0)
            total += incPvp
          })
        })
      }
      return total.toFixed(2)
    }
  },
  methods: {
    onSelectedFormat(format) {
      this.selectedFormat = format
    },
    onOptionMenuSelected(extraOption) {
      this.menu_option_opened = extraOption
      const { extra, option } = extraOption
      const product = this.$store.state.catalog_products.find(
        p => p.CODARTICULO === option.CODARTICULO
      )
      const catalog_modificadores = this.$store.getters.catalog_modificadores
      // FORMATOS
      this.menu_product_formats = []
      if (product.FORMATOS) {
        product.FORMATOS.forEach(f => {
          const formato = this.$store.state.catalog.FORMATOS.find(
            cf => cf.CODMODIFICADOR === f
          )
          this.menu_product_formats.push(formato)
        })
      }
      // MODIFICADORES
      this.menu_product_extras = []
      if (product.MODIFICADORES) {
        if (product.GRUPOSEXTRAS) {
          const grupos = Object.keys(product.GRUPOSEXTRAS)
          let extras = []
          grupos.forEach(k => {
            let grupo = product.GRUPOSEXTRAS[k]
            grupo.CODMODIFICADOR = k
            grupo.DESCRIPCION = grupo.description
            grupo.LIMITE = grupo.max
            grupo.MINIMO = grupo.min
            extras.push(grupo)
          })
          this.menu_product_extras = extras
        } else {
          // console.log('product.MODIFICADORES', product.MODIFICADORES)
          product.MODIFICADORES.forEach(m => {
            const modificador = Object.assign(
              {},
              catalog_modificadores.find(
                cm => cm.CODMODIFICADOR === m.CODMODIFICADOR
              )
            )
            modificador.CODOPCIONES = modificador.OPCIONES
            // console.log('modificador', modificador.OPCIONES)
            modificador.OPCIONES = []
            // console.log('modificador.CODOPCIONES', modificador.CODOPCIONES)
            modificador.CODOPCIONES.forEach(o => {
              const opcion = this.$store.getters.catalog_opciones.find(
                co => co.CODARTICULO === o
              )
              const articulo = this.$store.state.catalog_products.find(
                p => p.CODARTICULO === o
              )
              const opcionArticulo = Object.assign({}, articulo, opcion)
              modificador.OPCIONES.push(opcionArticulo)
              modificador.DESCRIPCION = modificador.DESCRIPCION.replace(
                product.DESCRIPCION,
                ''
              )
            })
            this.menu_product_extras.push(modificador)
          })
        }
      }
      // PRODUCTO
      this.menu_product = product
    },
    onOptionsChanged(selected) {
      const { extra, options } = selected
      this.selectedExtras = this.selectedExtras.filter(
        e => e.extra.CODMODIFICADOR !== extra.CODMODIFICADOR
      )
      this.selectedExtras.push(selected)
    },
    onMenuProductOptionsChanged(selected) {
      const { extra, options } = selected
      this.selectedMenuProductExtras = this.selectedMenuProductExtras.filter(
        e => e.extra.CODMODIFICADOR !== extra.CODMODIFICADOR
      )
      this.selectedMenuProductExtras.push(selected)
    },
    onAddToProductExtra() {
      const optionOpened = this.menu_option_opened
      const extraSelecected = this.selectedExtras.find(
        e => e.extra.CODMODIFICADOR === optionOpened.extra.CODMODIFICADOR
      )
      extraSelecected.options.forEach(o => {
        if (o.CODARTICULO === optionOpened.option.CODARTICULO) {
          o.OPTIONS = this.selectedMenuProductExtras
        }
      })

      this.menu_option_opened = {}
      this.menu_product = {}
      this.menu_product_formats = {}
      this.menu_product_extras = []
    },
    onUdsChanged(uds) {
      this.uds = uds
    },
    onAddToCart() {
      const product = this.product
      const format = this.format
      const extras = this.extras || []

      this.errors = []
      let errors = []

      if (this.formats && this.formats.length > 0 && !this.selectedFormat) {
        alert('DEBE SELECCIONAR UN FORMATO PARA EL PRODUCTO')
        return false
      }

      if (this.extras && this.extras.length > 0) {
        const selected = this.selectedExtras
        this.extras.forEach(e => {
          const min = e.ESMENU && e.MINIMO === 0 ? 1 : e.MINIMO
          let count = 0
          selected.forEach(s => {
            const { extra, options } = s
            if (extra.CODMODIFICADOR === e.CODMODIFICADOR) {
              count += options.length
            }
          })
          if (count < min) errors.push(`SELECCIONA ${min} ${e.DESCRIPCION}`)
        })
      }

      if (errors.length > 0) {
        this.$store.commit('setError', errors)
        return false
      }
      this.$emit('addProduct', {
        ...product,
        UDS: this.uds,
        FORMAT: this.selectedFormat,
        EXTRAS: this.selectedExtras,
        TOTAL: Number(this.getTotal)
      })
    },
    closeAddModal() {
      this.$emit('closeAddModal')
    },
    closeMenuAddModal() {
      this.menu_option_opened = {}
      this.menu_product = {}
      this.menu_product_formats = {}
      this.menu_product_extras = []
    }
  }
}
</script>

